module.exports = __webpack_public_path__ + "media/images/accordion-navy-collapse-07ef8bb15f60987a2aa02aec2037c428.svg";